import { useQuery } from '@apollo/client/react';
import { useState } from 'react';

import { SeoPageType } from '@pflegia/types/common/seo-page-meta/seo-page-meta';
import { normalizeSeoPagePath } from '@pflegia/util/common/seo-page-meta';

import { GET_SEO_PAGE_META, SeoPageMetaProp } from '@shared/graphql/operations/seo-page-meta';

interface UseJobBoardSeoMetaParams {
  initialSeoMeta?: SeoPageMetaProp | null;
  pageType: SeoPageType | null;
  listingPath: string;
  isDisabled?: boolean;
}

export const useJobBoardSeoMeta = ({ initialSeoMeta, pageType, listingPath, isDisabled = false }: UseJobBoardSeoMetaParams) => {
  const path = normalizeSeoPagePath(listingPath);
  const [initialPath] = useState(path);
  const isInitialPath = path === initialPath;
  const variables = pageType && path ? { pageType, path } : undefined;

  const { data, loading } = useQuery(GET_SEO_PAGE_META, { variables, skip: !variables || isInitialPath || isDisabled });

  if (isInitialPath) return { seoMeta: initialSeoMeta ?? null, isLoading: false };
  if (!variables || isDisabled) return { seoMeta: null, isLoading: false };

  return { seoMeta: data?.seoPageMeta ? { ...data.seoPageMeta, path: variables.path } : null, isLoading: loading };
};
